import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { AvailableHomesPage } from './pages/AvailableHomesPage';
import { ReferralPartnersPage } from './pages/ReferralPartnersPage';
import { ContactPage } from './pages/ContactPage';
import { useScreenInit } from './useScreenInit';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [pathname]);
  return null;
}
export function App() {
  // useScreenInit hook for Magic Patterns screen state initialization
  useScreenInit();
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="flex flex-col min-h-screen" data-id="element-2">
        <Navbar data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/homes" element={<AvailableHomesPage data-id="element-13" />} data-id="element-12" />
            <Route path="/referrals" element={<ReferralPartnersPage data-id="element-15" />} data-id="element-14" />
            <Route path="/contact" element={<ContactPage data-id="element-17" />} data-id="element-16" />
          </Routes>
        </main>
        <Footer data-id="element-18" />
      </div>
    </BrowserRouter>;
}